export const parseCategory = (category) => {
  let catName = category.nomeCategoria;

  if (category.categoriaSuperior) {
    catName = `${category.categoriaSuperior.nomeCategoria} > ${catName}`;
  }

  if (category.categoriaSuperior?.categoriaSuperior) {
    catName = `${category.categoriaSuperior.categoriaSuperior.nomeCategoria} > ${catName}`;
  }

  return catName;
};

export const parseFirstCategory = (category) => {
  let catName = category.nomeCategoria;

  if (category.categoriaSuperior) {
    catName = category.categoriaSuperior.nomeCategoria;
  }

  if (category.categoriaSuperior?.categoriaSuperior) {
    catName = category.categoriaSuperior.categoriaSuperior.nomeCategoria;
  }

  return catName;
};

export const parseLastCategory = (category) => {
  let catName = category.nomeCategoria;

  return catName;
};
